<div class="container-fluid" #container>
  <div class="row">
    <div class="col-md-3">
      <mat-card appearance="filled">
        <mat-card-header>
          <mat-form-field class="attributeFilter" id="attributeFilter" appearance="outline">
            <mat-label>
              @if (!displayAttributesSelection) {
                <language
                  key="FilterbuilderAttributeFilter"
                  defaultValue="Filter Attributes (Ctrl+F)"
                ></language>
              }
              @if (displayAttributesSelection) {
                <language
                  key="FilterbuilderDisplayAttributeFilter"
                  defaultValue="Search Display Columns (Ctrl+F)"
                ></language>
              }
            </mat-label>
            <input
              type="text"
              [attr.aria-label]="
                displayAttributesSelection
                  ? 'Search Display Columns - Press Enter to toggle selection'
                  : 'Filter Attributes - Press Enter to add first match'
              "
              matInput
              [formControl]="attributeFilterFormControl"
              autocomplete="off"
              #attributeFilterInput
              (keydown)="handleAttributeFilterKeydown($event)"
            />
            @if (attributeFilterFormControl.value) {
              <button
                matSuffix
                matIconButton
                aria-label="Clear"
                matTooltip="Clear (Esc)"
                (click)="clearAttributeFilter()"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </mat-card-header>
        <mat-card-content>
          <mat-card appearance="raised">
            <mat-card-content>
              @if (!displayAttributesSelection) {
                <div class="attribute-list">
                  <!-- Frequently Used Attributes Section -->
                  @if ((frequentAttributes | async)?.length > 0) {
                    <div class="frequent-attributes-section">
                      <div class="group">
                        <div class="group-icon">
                          <mat-icon>star</mat-icon>
                        </div>
                        <div class="group-items">
                          <div class="frequent-header">
                            <language
                              key="FilterbuilderFrequentlyUsed"
                              defaultValue="Frequently Used"
                            ></language>
                          </div>
                          @for (at of frequentAttributes | async; track at) {
                            <button
                              mat-button
                              (click)="addFilter(at)"
                              matTooltipShowDelay="1000"
                              matTooltipPosition="left"
                              class="frequent-attribute-button"
                              [matTooltip]="
                                at.Name +
                                ' (' +
                                at.DataType +
                                (at.Multivalued ? ', MV' : '') +
                                ') - Frequently used'
                              "
                            >
                              {{ at.DisplayName }}
                            </button>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  <!-- Regular Alphabetical Attributes -->
                  @for (a of attributes | async; track a) {
                    <div class="group">
                      <div class="group-icon">
                        {{ a.code }}
                      </div>
                      <div class="group-items">
                        @for (at of a.attrs; track at) {
                          <button
                            matButton
                            (click)="addFilter(at)"
                            matTooltipShowDelay="1000"
                            matTooltipPosition="left"
                            [matTooltip]="
                              at.Name +
                              ' (' +
                              at.DataType +
                              (at.Multivalued ? ', MV' : '') +
                              ') - Click or Enter to add'
                            "
                          >
                            {{ at.DisplayName }}
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <div class="attribute-list display-attribute-list">
                  @for (a of allAttributes | async; track a) {
                    <div class="group">
                      <div class="group-icon">{{ a.code }}</div>
                      <div class="group-items">
                        @for (at of a.attrs; track at) {
                          <mat-button-toggle
                            [checked]="isDisplayedAttribute(at)"
                            (change)="changeDisplayedAttribute($event.source.checked, at)"
                            matTooltipShowDelay="2000"
                            matTooltipPosition="left"
                            [matTooltip]="
                              at.Name + ' (' + at.DataType + (at.Multivalued ? ' , MV)' : ')')
                            "
                          >
                            {{ at.DisplayName }}
                          </mat-button-toggle>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </mat-card-content>
          </mat-card>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-md-9 filterBuilder" [class.is-dragging]="isDragging" #filterBuilderPanel>
      <mat-card appearance="filled" class="filter-card">
        <mat-card-header>
          <mat-card-title>
            <language key="FilterbuilderFilterTitle" defaultValue="Filter for"></language>
          </mat-card-title>
          <mat-form-field class="objectTypeSelection" appearance="outline">
            <mat-label>
              <language key="FilterbuilderObjectType" defaultValue="Resource Type"></language>
            </mat-label>
            <input
              type="text"
              aria-label="Resource Type"
              matInput
              #otInput
              (blur)="blurObjectType()"
              (focus)="focusObjectType()"
              [formControl]="objectTypeFormControl"
              [matAutocomplete]="auto"
              autocomplete="off"
            />
            <mat-autocomplete
              #auto="matAutocomplete"
              [displayWith]="displayFn"
              autoActiveFirstOption
              (optionSelected)="objectTypeSelected()"
            >
              @for (ot of filteredObjectTypes | async; track ot) {
                <mat-option [value]="ot">
                  {{ ot.displayname }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </mat-card-header>
        <mat-card-content>
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="!displayAttributesSelection"
              (opened)="displayAttributesSelection = false"
              (closed)="displayAttributesSelection = true"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ searchScope.xpath }}
                </mat-panel-title>
                <button
                  mat-icon-button
                  matSuffix
                  (click)="copyToClipboard(searchScope.xpath); $event.stopPropagation()"
                  class="me-3"
                >
                  <mat-icon>content_copy</mat-icon>
                </button>
              </mat-expansion-panel-header>

              @if (mainFilterGroup.filters.length !== 0) {
                <div class="mainFilterGroup">
                  <mat-radio-group [(ngModel)]="mainFilterGroup.operator" class="operator">
                    <mat-radio-button value="all">
                      <language key="FilterbuilderOperatorAll" defaultValue="All"></language>
                    </mat-radio-button>
                    <mat-radio-button value="any">
                      <language key="FilterbuilderOperatorAny" defaultValue="Any"></language>
                    </mat-radio-button>
                  </mat-radio-group>
                  <div [dragula]="dragulaName" [attr.data-filterid]="mainFilterGroup.id">
                    @for (f of mainFilterGroup.filters; track f) {
                      <div>
                        @if (isFilterGroup(f)) {
                          <div class="filterGroup" [attr.data-filterid]="f.id">
                            <mat-radio-group [(ngModel)]="f.operator" class="operator">
                              <mat-radio-button value="all">
                                <language
                                  key="FilterbuilderOperatorAll"
                                  defaultValue="All"
                                ></language>
                              </mat-radio-button>
                              <mat-radio-button value="any">
                                <language
                                  key="FilterbuilderOperatorAny"
                                  defaultValue="Any"
                                ></language>
                              </mat-radio-button>
                            </mat-radio-group>
                            <div [dragula]="dragulaName">
                              @for (f2 of f.filters; track f2) {
                                <div
                                  class="filter"
                                  [attr.data-filterid]="f2.id"
                                  [class.filter-selected]="selectedFilterId === f2.id"
                                  (click)="selectFilter(f2.id)"
                                  (keydown)="handleFilterKeydown($event, f2, f)"
                                  tabindex="0"
                                >
                                  <div class="filter-wrapper">
                                    <filter [filter]="f2"></filter>
                                    <button
                                      mat-icon-button
                                      (click)="removeFilter(f2, f)"
                                      class="bt-remove mat-icon-button-error-color"
                                      matTooltip="Remove (Del)"
                                    >
                                      <mat-icon>remove_circle</mat-icon>
                                    </button>
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                        @if (!isFilterGroup(f)) {
                          <div
                            class="filter"
                            [attr.data-filterid]="f.id"
                            [class.filter-selected]="selectedFilterId === f.id"
                            (click)="selectFilter(f.id)"
                            (keydown)="handleFilterKeydown($event, f, mainFilterGroup)"
                            tabindex="0"
                          >
                            <div class="filter-wrapper">
                              <filter [filter]="f"></filter>
                              <button
                                mat-icon-button
                                (click)="removeFilter(f, mainFilterGroup)"
                                class="bt-remove mat-icon-button-error-color"
                                matTooltip="Remove (Del)"
                              >
                                <mat-icon>remove_circle</mat-icon>
                              </button>
                            </div>
                            <div class="group-drop-zone" [dragula]="'filter-bag'"></div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <mat-card appearance="filled" class="alert-card">
                  <mat-card-content>
                    <language
                      key="FilterbuilderNoFilters"
                      defaultValue="Select an attribute to add a filter • Ctrl+F to search • Type any letter to jump"
                    ></language>
                  </mat-card-content>
                </mat-card>
              }

              <!-- Keyboard action feedback -->
              @if (toggleFeedbackMessage) {
                <div class="keyboard-feedback">
                  <mat-icon>check_circle</mat-icon>
                  <span>{{ toggleFeedbackMessage }}</span>
                </div>
              }

              <div class="parser">
                <mat-form-field>
                  <mat-label>
                    <language
                      key="FilterbuilderXpathInput"
                      defaultValue="Custom XPath (Enter to parse)"
                    ></language>
                  </mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="xpathCustom"
                    autocomplete="off"
                    (keydown.enter)="onParse()"
                  />
                  <button mat-icon-button matSuffix (click)="copyToClipboard(xpathCustom)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                  @if (xpathInvalid) {
                    <mat-hint class="mat-mdc-form-field-error">
                      <language
                        key="FilterbuilderXpathInvalid"
                        defaultValue="The entered XPath is invalid."
                      ></language>
                    </mat-hint>
                  }
                  @if (xpathUnknown) {
                    <mat-hint class="mat-mdc-form-field-error">
                      <language
                        key="FilterbuilderXpathUnknown"
                        defaultValue="The entered XPath uses an unknown resource type or unknown attributes."
                      ></language>
                    </mat-hint>
                  }
                  @if (xpathUnsupported) {
                    <mat-hint class="mat-mdc-form-field-error">
                      <language
                        key="FilterbuilderXpathUnsupported"
                        defaultValue="The entered XPath is not supported by the filter builder."
                      ></language>
                    </mat-hint>
                  }
                </mat-form-field>
                <button mat-raised-button class="btn-parse" (click)="onParse()" matTooltip="Enter">
                  <language key="FilterbuilderParse" defaultValue="Parse"></language>
                </button>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-card-content>
      </mat-card>

      <mat-card appearance="filled">
        <smd-datatable
          #searchResult
          [hidden]="selectedObjectType == null"
          [paginated]="true"
          [title]="filterResultTitle | async"
          [defaultPageSize]="10"
          [mergeRemoteAndLocal]="false"
          [responsive]="true"
          [showLoadingTime]="true"
          (onAddView)="onAddView.emit($event)"
        >
          <mat-button-toggle
            [checked]="displayAttributesSelection"
            (change)="displayAttributesSelection = $event.source.checked; scrollToTop()"
            class="btn-selectDisplayAttributes datatable-title-button"
          >
            <language
              key="FilterbuilderSelectDisplayAttributes"
              defaultValue="Select displayed Attributes"
            ></language>
            @if (displayAttributeCount > 0) {
              <span class="attribute-count"> ({{ displayAttributeCount }}) </span>
            }
          </mat-button-toggle>
          <smd-datatable-header [actionBarConfigs]="listActionBarConfigs"></smd-datatable-header>
        </smd-datatable>
      </mat-card>
    </div>
  </div>
</div>
